<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>Administración</span>
</mat-toolbar>

<div class="admin-page">
  <p class="admin-subtitle">Panel de control del torneo</p>

  <div class="admin-grid">
    <mat-card
      class="admin-card"
      (click)="showMatches()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--matches">
        <mat-icon>sports_soccer</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Partidos</h3>
        <p class="admin-card__desc">
          Gestiona resultados y estado de los partidos del torneo.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showFinalResult()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--champion">
        <mat-icon>workspace_premium</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Campeón y Pichichi</h3>
        <p class="admin-card__desc">
          Define el campeón del torneo y el máximo goleador.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showUsers()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--users">
        <mat-icon>people</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Participantes</h3>
        <p class="admin-card__desc">
          Consulta y administra los usuarios registrados en la porra.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showGroups()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--groups">
        <mat-icon>supervised_user_circle</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Grupos</h3>
        <p class="admin-card__desc">
          Crea y gestiona los grupos de la competición.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showCommunications()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--comms">
        <mat-icon>campaign</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Comunicados</h3>
        <p class="admin-card__desc">
          Envía comunicados a todos los usuarios registrados.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showEmailTemplates()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--email">
        <mat-icon>mark_email_read</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Plantillas de email</h3>
        <p class="admin-card__desc">
          Edita los correos automáticos del sistema.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showRoundSummaries()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--summaries">
        <mat-icon>summarize</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">Resúmenes</h3>
        <p class="admin-card__desc">
          Genera y envía resúmenes de rondas y jornadas.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="admin-card"
      (click)="showWhatsAppStatus()"
      tabindex="0"
      role="button"
    >
      <div class="admin-card__icon-wrap admin-card__icon-wrap--whatsapp">
        <mat-icon>chat</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="admin-card__title">WhatsApp</h3>
        <p class="admin-card__desc">
          Consulta la conexión de la instancia y fuerza el arranque si hace
          falta.
        </p>
      </mat-card-content>
      <div class="admin-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>
  </div>
</div>
